<template>
    <div class="pt-12">
        <div class="orc-vert-limit-header">
            <h1 class="text-2xl mb-10"><i class="el-icon-medal mr-3"></i>{{ branch.title }}</h1>
        </div>

        <div class="orc-vert-limit-header">

            <div class="mb-6">
                <content-displayer :current="branch.fullDescription"></content-displayer>
            </div>

            <div class="mt-4 flex">
                <el-tooltip class="item" effect="dark" content="Inschrijvingen voor deze tak zijn uitgeschakeld." placement="top" :disabled="branch.isActive">
                    <div class="inline-block">
                        <div class="mr-2 mt-2 inline-block">
                          <el-button type="primary" :disabled="!branch.isActive" @click="enroll()">Inschrijven<i class="ml-2 el-icon-plus"></i></el-button>
                        </div>
                        <div class="mt-2 inline-block">
                          <el-button type="info" @click="questions()">Veelgestelde Vragen<i class="ml-2 el-icon-bottom"></i></el-button>
                        </div>
                    </div>
                </el-tooltip>
            </div>
        </div>
    </div>
</template>

<script>
    import ContentDisplayer from "../content/ContentDisplayer";
    import Photos from "../photos/Photos";
    export default {
        name: "Branch",
        props: ['branch'],
        components: {
            ContentDisplayer,
            Photos
        },
        methods: {
            enroll() {
                this.$parent.showEnrollmentDialog(this.branch.id)
            },

            questions() {
                window.location.hash = "#questions";
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/home/branches/Branch.vue